import { Action } from '@ngrx/store';
import { RefNo } from '../../model/ngrx/reference-number.model';
import * as LoggedinDetailActions from './../actions/loggedin-detail.action';

export type Actions = LoggedinDetailActions.Actions;

export function LoggedinDetailReducer(state: [] = [], action: LoggedinDetailActions.Actions) {
    switch (action.type) {
        case LoggedinDetailActions.ADD_LOGGED_IN_DETAIL:
            return [...state, action.payload];
        // return newState(state, { quoteReferenceNumber: action.payload });

        // Add this case:
        case LoggedinDetailActions.REMOVE_LOGGED_IN_DETAIL:
            return []; //[...state].splice(action.payload, 1);
        default:
            return state;
    }
}
